import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { PaywallGetBillingCountriesDoc, PaywallGetBillingCountriesQuery } from '@minecraft.graphql-operations';

export type BillingOption = {
  id: string;
  label: string;
};

export type BillingCountryOption = BillingOption & {
  countryId: number;
};

export const useBillingCountries = (skip = false) => {
  const { data, loading, error } = useQuery<PaywallGetBillingCountriesQuery>(PaywallGetBillingCountriesDoc, { skip });

  return useMemo(() => {
    const countryOptions: BillingCountryOption[] =
      data?.getBillingCountries?.reduce((countryOpts, country) => {
        if (!country?.code || !country?.name || country.id == null) {
          return countryOpts;
        }

        countryOpts.push({
          id: country.code,
          label: country.name,
          countryId: country.id,
        });

        return countryOpts;
      }, [] as BillingCountryOption[]) ?? [];

    const namesByCode = new Map(countryOptions.map((country) => [country.id, country.label]));
    return {
      countryOptions,
      getCountryName: (code: string): string | undefined => (code ? namesByCode.get(code) ?? code : undefined),
      countriesLoading: loading,
      countriesError: error,
    };
  }, [data, loading, error]);
};
